import { Type } from '@angular/core';

export interface ComponentDefinition {
  type: string;
  component: Type<unknown>;
  category?: 'atomos' | 'moleculas' | 'organismos' | 'templates' | 'pages';
}

export class ComponentRegistry {
  private readonly registry = new Map<string, ComponentDefinition>();

  public register(definition: ComponentDefinition): void {
    this.registry.set(definition.type, definition);
  }

  public registerMany(definitions: ComponentDefinition[]): void {
    definitions.forEach((def) => this.register(def));
  }

  public get(type: string): Type<unknown> | undefined {
    return this.registry.get(type)?.component;
  }

  public getDefinition(type: string): ComponentDefinition | undefined {
    return this.registry.get(type);
  }

  public has(type: string): boolean {
    return this.registry.has(type);
  }

  public getAllTypes(): string[] {
    return Array.from(this.registry.keys());
  }

  public getByCategory(category: ComponentDefinition['category']): ComponentDefinition[] {
    return Array.from(this.registry.values()).filter((def) => def.category === category);
  }

  public clear(): void {
    this.registry.clear();
  }

  public size(): number {
    return this.registry.size;
  }
}

export const componentRegistry = new ComponentRegistry();
